import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";

const links = [
  { to: "/", label: "Home" },
  { to: "/preisvergleich", label: "Preisvergleich" },
  { to: "/kontakt", label: "Kontakt" },
] as const;

export function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass py-3" : "py-6 bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="relative grid h-8 w-8 place-items-center rounded-md border-2 border-foreground bg-primary text-primary-foreground -rotate-6 transition-transform group-hover:rotate-0">
            <span className="absolute -top-1 -left-1 h-2.5 w-2.5 rounded-full border-2 border-foreground bg-background" />
            <span className="h-2.5 w-2.5 rounded-full border-2 border-primary-foreground" />
          </span>
          <span className="font-display font-semibold tracking-tight text-foreground">
            Tarifvergleiche<span className="text-primary">.com</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="relative px-4 py-2 text-sm font-medium text-foreground/70 transition-colors hover:text-foreground"
              activeProps={{ className: "text-foreground" }}
            >
              {({ isActive }) => (
                <>
                  <span>{l.label}</span>
                  {isActive && (
                    <span className="absolute left-3 right-3 -bottom-0.5 h-[2.5px] rounded-full bg-primary" />
                  )}
                </>
              )}
            </Link>
          ))}
          <Link
            to="/preisvergleich"
            className="ml-3 rounded-full border-2 border-foreground bg-foreground px-5 py-2 text-sm font-semibold text-background transition-colors hover:bg-primary hover:border-primary"
          >
            Preise vergleichen
          </Link>
        </nav>

        <button
          className="md:hidden h-10 w-10 grid place-items-center rounded-md border-2 border-foreground"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          <span className="block w-5 h-[2px] mb-1.5 bg-foreground" />
          <span className="block w-5 h-[2px] bg-foreground" />
        </button>
      </div>

      {open && (
        <div className="md:hidden glass mt-3 mx-6 rounded-xl p-2 ticket-shadow">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block px-4 py-3 text-sm font-medium rounded-md hover:bg-secondary"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
